"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_input_foundations_Radio_Radio = require("../../input/foundations/Radio/Radio.js");
const Badge_module = require("../../../chunks/Badge.module-qXTkEAZZ.js");
const BadgeRadio = React.forwardRef(
  ({ children, value, className, ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsx(
      components_input_foundations_Radio_Radio.Radio,
      {
        ref,
        value,
        className: clsx.clsx(Badge_module.styles.badge, className),
        selectedClassName: Badge_module.styles.badgeIsSelected,
        pressedClassName: Badge_module.styles.badgeIsPressed,
        focusedClassName: Badge_module.styles.badgeIsFocused,
        ...props,
        children: /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { variant: "text-body-head", component: "span", className: Badge_module.styles.badgeText, children })
      }
    );
  }
);
exports.BadgeRadio = BadgeRadio;
